import { gtmEvent, getGtmTagValue } from '../../utils/gtmEvents';
const gtmFilterSelectionList = (formattedFilterSelectionList) => {
    const gtmPayload = {
        event: 'dealer_inventory_filter',
        filter_selection_list: getGtmTagValue(formattedFilterSelectionList),
    };
    gtmEvent(gtmPayload);
};
export default gtmFilterSelectionList;
